/**
 * Mobile WebViews (especially Android) are sensitive to:
 * - HTMLMediaElement.load() while playing (buffer reset / stutter)
 * - Aggressive "health" restarts that call stopAllAudio + play again
 * - Manual loop repair (pause/seek/play) fighting native loop
 */

/** True when we should avoid aggressive music recovery (Android / iOS WebView / Capacitor). */
export function getMobileGentleMusicMode() {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const ua = navigator.userAgent || '';
  if (/Android/i.test(ua)) {
    return true;
  }
  if (/iPhone|iPad|iPod/i.test(ua)) {
    return true;
  }
  if (typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()) {
    return true;
  }
  return false;
}
